// options will be in redux
export const plainOptions = ['Seal (1000)', 'Mine (500)', 'Urgent', 'Gold Test'];
export const looseStoneService = ['Apprasial Card', 'Apprasial Certificate', 'Consultation', 'Gemstone Card', 'Gemstone Certificate', 'Diamond Card', 'Diamond Certificate']
export const jewelleryService = ['Apprasial Card', 'Apprasial Certificate', 'Jewellery Card', 'Jewellery Certificate', 'Gemstone Jewellery Card', 'Gemstone Jewellery Certificate']
export const strandService = ['Apprasial Card', 'Apprasial Certificate', 'Gemstone Strand Card', 'Gemstone Strand Certificate', 'Pearl Strand Card', 'Pearl Strand Certificate',]
export const CVDTestingService = ['CVD Testing (Lots)']
export const itemDescription = ['Ring', 'Pendent', 'Earing', 'Set', 'Bangle', 'Kara', 'Bracelet', 'Nose Pin', 'Neckless']
export const weightRangeOpt = ['0.1 - 0.49 ct', '0.50 - 0.99 ct', '1.00 - 1.49 ct', '1.50 - 1.99 ct', '2.00 - 2.99 ct', '3.00 - 3.99 ct', '4.00 - up']
export const weightOpt = ['g', 'ct', 'kg']
export let LoseStoneService = [
    { name: "Apprasial Card", price: 0, member_price: 0 },
    { name: "Apprasial Certificate", price: 0, member_price: 0 },
    { name: "Consultation", price: 0, member_price: 0 },
    { name: "Gemstone Card", price: 0, member_price: 0 },
    { name: "Gemstone Certificate", price: 0, member_price: 0 },
    { name: "Diamond Card", price: 0 },
    { name: "Diamond Certificate", price: 0 },
    { name: "Master Reports", price: 0, member_price: 0 },
    { name: "Verbal", price: 0, member_price: 0 },
    { name: "Master Pearl Report", price: 0, member_price: 0 },
    { name: "Pearl Testing", price: 0, member_price: 0 },
    { name: "No Decision", price: 0, member_price: 0 }
]

export let JewelleryService = [
    { name: "Apprasial Card", price: 0, member_price: 0 },
    { name: "Apprasial Certificate", price: 0, member_price: 0 },
    { name: "Consultation", price: 0, member_price: 0 },
    { name: "Jewellery Card", price: 0 },
    { 0: "Jewellery Certificate", price: 0 },
    { 0: "Gemstone Jewellery Card", price: 0 },
    { 0: "Gemstone Jewellery Certificate", price: 0 },
    { 0: "Gold Test", price: 0, member_price: 0 },
    { name: "No Decision", price: 0, member_price: 0 }
]
export let StrandService = [
    { name: "Apprasial Card", price: 0, member_price: 0 },
    { name: "Apprasial Certificate", price: 0, member_price: 0 },
    { name: "Gemstone Strand Card", price: 0, member_price: 0 },
    { name: "Gemstone Strand Certificate", price: 0, member_price: 0 },
    { name: "Pearl Strand Card", price: 0, member_price: 0 },
    { name: "Pearl Strand Certificate", price: 0, member_price: 0 },
    { name: "No Decision", price: 0, member_price: 0 }
]
export let CVDTesting = [
    { name: "Between 0.01 to 1", price: 0, member_price: 0 },
    { name: "Between 1.01 to 5", price: 0, member_price: 0 },
    { name: "Extra More than 5", price: 0, member_price: 0 },
    { name: "No Decision", price: 0, member_price: 0 }
]
export let DiamondCertificate = [
    { name: "0.01 - 0.49 ct", price: 0, member_price: 0 },
    { name: "0.50 - 0.99 ct", price: 0, member_price: 0 },
    { name: "1.00 - 1.49 ct", price: 0, member_price: 0 },
    { name: "1.50 - 1.99 ct", price: 0, member_price: 0 },
    { name: "2.00 - 2.99 ct", price: 0, member_price: 0 },
    { name: "3.00 - 3.99 ct", price: 0, member_price: 0 },
    { name: "4.00 - up", price: 0, member_price: 0 },
    { name: "No Decision", price: 0, member_price: 0 }
]
export let DiamondCard = [
    { name: "0.01 - 0.49 ct", price: 0, member_price: 0 },
    { name: "0.50 - 0.99 ct", price: 0, member_price: 0 },
    { name: "1.00 - 1.49 ct", price: 0, member_price: 0 },
    { name: "1.50 - 1.99 ct", price: 0, member_price: 0 },
    { name: "2.00 - 2.99 ct", price: 0, member_price: 0 },
    { name: "3.00 - 3.99 ct", price: 0, member_price: 0 },
    { name: "4.00 - up", price: 0, member_price: 0 },
    { name: "No Decision", price: 0, member_price: 0 }
]
export let extraService = [
    { name: "Seal", price: 0 },
    { name: "Mine", price: 0 },
    { name: "Urgent", price: 0 },
    { name: "Gold Test", price: 0 }
]

export const mineralSampleTypes = ['Mineral', 'Ore', 'Rock', 'Other']

export const mineralAnalysisTypes = [
    'Chemical Analysis',
    'Mineral Identification',
    'XRF',
    'FTIR',
    'Raman',
    'Destructive Test',
    'ICP-OES / ICP-MS',
    'AAS'
]

export let MineralAnalysisPrice = [
    { name: "Chemical Analysis", price: 0, member_price: 0 },
    { name: "Mineral Identification", price: 0, member_price: 0 },
    { name: "XRF", price: 0, member_price: 0 },
    { name: "FTIR", price: 0, member_price: 0 },
    { name: "Raman", price: 0, member_price: 0 },
    { name: "Destructive Test", price: 0, member_price: 0 },
    { name: "ICP-OES / ICP-MS", price: 0, member_price: 0 },
    { name: "AAS", price: 0, member_price: 0 }
]